import React, { useState, useContext } from 'react';
import { Container, Grid, Typography, Card, CardContent, CardMedia, IconButton, Modal, Button, TextField } from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import avatar from '../../images/doctorAvatatr.jpg'
import './OrganizationProfile.css'
import axios from 'axios';
import Swal from 'sweetalert2';
import UserContext from "../../Context/User/userContext";

const PersonalProfile = ({ setShowSpinner }) => {
  //Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : ""
  // User Object
  const { user, setUser } = useContext(UserContext);

  const userContextObj = user ? (typeof user == "string" ? JSON.parse(user) : user) : {
    firstName: null,
    lastName: null,
    email: null,
    organizationName: null,
    organizationType: null,
    country: null,
    region: null,
    city: null,
    state: null,
  };

  const [profilePicture, setProfilePicture] = useState(userContextObj && userContextObj.profilePic?.url || avatar);

  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [newProfilePicture, setNewProfilePicture] = useState("");
  const [fileValue, setFileValue] = useState("");
  const [profileInfo, setProfileInfo] = useState({
    firstName: userContextObj.firstName,
    lastName: userContextObj.lastName,
    email: userContextObj.email,
    organizationName: userContextObj.organizationName,
    organizationType: userContextObj.organizationType,
    country: userContextObj.country,
    region: userContextObj.region,
    city: userContextObj.city,
    state: userContextObj.state,
  });

  const handleOpenUploadModal = () => {
    setOpenUploadModal(true);
  };

  const handleCloseUploadModal = () => {
    setOpenUploadModal(false);
  };

  const handleProfilePictureChange = (e) => {
    setNewProfilePicture(URL.createObjectURL(e.target.files[0]));
    setFileValue(e.target.files[0]);

  };

  const handleSaveProfilePicture = () => {
    if (profilePicture === "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava1-bg.webp") {
      setProfilePicture(newProfilePicture);
    }
    handleCloseUploadModal();
    handleUpload()
  };

  const handleUpload = () => {
    setShowSpinner(true);

    // Extract file type
    const fileType = fileValue.type.split("/").pop();
    console.log(fileType)

    // Validate file type
    if (["png", "jpg", "jpeg"].includes(fileType)) {
      const formData = new FormData();
      formData.append('file', fileValue);

      const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/auth/uploadProfile?name=${userContextObj._id}`;

      axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${tokenValue}`
        }
      })
        .then(res => {
          // Handle success
          const user = res.data.user;
          if (localStorage.getItem('siteUser')) {
            localStorage.setItem("siteUser", JSON.stringify(user)); // Assuming "siteUser" is the key used
          } else {
            localStorage.setItem("user", JSON.stringify(user)); // Assuming "siteUser" is the key used
          }
          setUser(user);
          setProfilePicture(user.profilePic.url);

          Swal.fire({
            title: "Uploaded!",
            text: "Your profile picture has been uploaded",
            icon: "success",
            customClass: {
              container: 'swal2-container-custom'
            }
          });
        })
        .catch(error => {
          // Handle error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "An unexpected error occurred",
            customClass: {
              container: 'swal2-container-custom'
            }
          });
        })
        .finally(() => {
          setShowSpinner(false);
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "File type should be png, jpg, or jpeg",
        customClass: {
          container: 'swal2-container-custom'
        }
      });
      setShowSpinner(false);
    }
  };


  return (
    <section>
      <Container maxWidth="xl" className="mt-3 h-100">
        <Grid container justifyContent="center" alignItems="center" className="h-100">
          <Grid item lg={12} className="mb-4 mb-lg-0">
            <Card className="mb-3">
              <Grid container className="g-0">
                <Grid item md={3} className="gradient-custom text-center text-white" sx={{ borderTopLeftRadius: '.5rem', borderBottomLeftRadius: '.5rem', backgroundColor: '#178383', padding: '20px', position: 'relative' }}>
                  <CardMedia component="img" src={profilePicture.replaceAll('http:', 'https:')} className="my-5" style={{ height: '220px', width: '220px', objectFit: 'cover', margin: '0 auto', borderRadius: '50%', border: '2px solid #fff',background:'white' }} />
                  <IconButton
                    onClick={handleOpenUploadModal}
                    style={{
                      position: 'absolute',
                      right: '5px',
                      bottom: '5px',
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      padding: '5px'
                    }}
                  >
                    <PhotoCameraIcon />
                  </IconButton>
                </Grid>
                <Grid item md={9}>
                  <CardContent className="p-4">
                    {/* <Typography variant="h4">{profileInfo.firstName} {profileInfo.lastName}</Typography> */}

                    <h4 style={{color:'rgb(23 131 131)',textTransform:'capitalize',fontFamily:'cursive'}}>{profileInfo.firstName} {profileInfo.lastName}</h4>
                    <hr className="mt-0 mb-4" />
                    <Grid container className="pt-1">
                      <Grid item xs={6} className="mb-3">
                      <Typography className='text-labels' variant="h4">Email</Typography>
                        <Typography className="text-muted mt-2">{profileInfo.email}</Typography>
                      </Grid>
                      <Grid item xs={6} className="mb-3">
                        <Typography className='text-labels' variant="h4">Organization Name</Typography>
                        <Typography className="text-muted mt-2">{profileInfo.organizationName}</Typography>
                      </Grid>
                      <Grid item xs={6} className="mb-3">
                        <Typography className='text-labels' variant="h4">Organization Type</Typography>
                        <Typography className="text-muted mt-2">{profileInfo.organizationType}</Typography>
                      </Grid>
                      <Grid item xs={6} className="mb-3">
                        <Typography className='text-labels' variant="h4">Country</Typography>
                        <Typography className="text-muted mt-2">{profileInfo.country}</Typography>
                      </Grid>
                      <Grid item xs={6} className="mb-3">
                        <Typography className='text-labels' variant="h4">Region</Typography>
                        <Typography className="text-muted mt-2">{profileInfo.region}</Typography>
                      </Grid>
                      <Grid item xs={6} className="mb-3">
                        <Typography  className='text-labels' variant="h4">City</Typography>
                        <Typography className="text-muted mt-2">{profileInfo.city}</Typography>
                      </Grid>
                      <Grid item xs={6} className="mb-3">
                        <Typography className='text-labels' variant="h4">State</Typography>
                        <Typography className="text-muted mt-2">{profileInfo.state}</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Grid>
              </Grid>
            </Card >
          </Grid >
        </Grid >
      </Container >

      {/* Upload Modal */}
      < Modal
        open={openUploadModal}
        onClose={handleCloseUploadModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Card>
          <CardContent>
            <Typography variant="h5" component="h5" id="modal-title">
              Upload New Profile Picture
            </Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleProfilePictureChange}
              style={{
                /* Your styles here */
                fontSize: '1.4rem',
                color: '#169a8f', /* Text color */
                borderRadius: '5px', /* Border radius */
                cursor: 'pointer', /* Change cursor on hover */
                marginTop: 3,
              }}
            />
            <Button className='saveBtn' onClick={handleSaveProfilePicture}>Save</Button>
          </CardContent>
        </Card>
      </Modal >
    </section >
  );
}

export default PersonalProfile;
